"use strict";

import $ from 'jquery';
import { addAjaxErrorListener } from './endpoints/AjaxHandlers';
import notifier from './common/Notifier';
import {isValidDate} from './common/Utils';
import AccountSettingsService from './endpoints/AccountSettingsService';
import Urls from './endpoints/Urls';
import { amount, phoneNCAA, dateInPast, dateInFuture, dateAfterStart, uniqueUserName, passwordNCAA } from './common/validators';
import './common/Analytics';

// importing in a single place to initiate the monitor
import './common/SessionMonitor';

/**
 * Initializes jquery validator with default configurations
 */
function initializeValidators() {

    $.extend($.validator.messages, {
            required: "Required"
        });

    $.validator.setDefaults({
        //2023_02_06: Updated the "ignore" option to validate selectize input elements.
        //ignore : ':hidden:not(.validate)',
        /**
         * See https://gist.github.com/yannleretaille/8498983 to set up validator selectors when using selectize.js
         *
         * the default ignore selector is ':hidden', the following selectors restore the default behaviour when using selectize.js
         *
         * :hidden:not([class~=selectized]) | selects all hidden elements, but not the original selects/inputs hidden by selectize
         * :hidden > .selectized | to restore the behaviour of the default selector, the original selects/inputs are only validated if their parent is visible
         * .selectize-control .selectize-input input | this rule is not really necessary, but ensures that the temporary inputs created by selectize on the fly are never validated
         *
         **/
        ignore: ':hidden:not(.validate,[class~=selectized]), :hidden > .selectized, .selectize-control .selectize-input input',
        highlight: function (e) {
            $(e).closest('.form-group').addClass('has-error');
        },
        unhighlight: function (e) {
            $(e).closest('.form-group').removeClass('has-error');
        },
        errorPlacement: function(error, element)
        {
            let insertAfter = element;

            if (element.is(':radio') || element.is(':checkbox') || element.is('select')){
                insertAfter = $(element).closest('div');
            }

            let formGroup = element.closest('.form-group');
            if (formGroup.length === 1
                && formGroup.is('.condensed')
                && formGroup.find('.help-block').length > 0){

                formGroup.find('.help-block').prepend(error);
                return;
            }

            error.insertAfter(insertAfter);
        },
        focusInvalid: false,
        invalidHandler: function(form, validator) {

            if (!validator.numberOfInvalids())
                return;

            let el = $(validator.errorList[0].element);
            let parent = el.closest('.content-section, .content-wrap');
            let scrolltop = (el.offset() && parent.offset()) ? (el.offset().top - parent.offset().top - 10) : 0;

            $('html, body').animate({
                scrollTop: scrolltop
            }, {duration : 500,
                complete : function(){
                    el.trigger('focus');
                }
            });
        }
    });

    //override default date validator to make all date as MM/DD/YYYY
    $.validator.methods.date = isValidDate;
    $.validator.messages['date'] = 'Enter date as MM/DD/YYYY';

    //TODO: refactor validators to specific pages where they are used
    amount.addMethod();
    phoneNCAA.addMethod();
    dateInPast.addMethod();
    dateInFuture.addMethod();
    dateAfterStart.addMethod();
    uniqueUserName.addMethod();
    passwordNCAA.addMethod();
}

/**
 * Initialize all global exception handlers
 */
function wireUpExceptionHandlers() {

    addAjaxErrorListener(function (error) {
        if (error.data.status === 401 && !error.isJSON) {
            let returnUrl = window.location.pathname.replace(Urls.getContextRoot(), '/');
            window.location = Urls.getContextRoot() + `/login?returnUrl=/${returnUrl}`;
        }
        else {
            notifier.error(error.message, "Ajax Error");
        }
    });
}

function wireUpMobileLayout(){
    // Subnav mobile toggle
    $('.nav-toggle').on('click', function(e){
        $(this).parent('.subnav').toggleClass('open');
    });

    // Secondary nav toggle
    $('#sidebar > .nav > li > .parent').on('click', function(e){
        var subnavID = $(this).data('subnav');
        if( $('#sidebar > .nav > li > .parent').parent().css('display') == "inline-block" ) {
            e.preventDefault();
            $('#' + subnavID +'.nav-sm').toggleClass('open');
        }
    });

    // Content tabs mobile toggle
    $('.content-tabs .nav-tabs').on('click', function(e){
        if( $(this).children('li').css('display') == "block" ) {
            $(this).parent().toggleClass('open');
        }
    });
}

function openTasksCount() {
    let taskCountAlert = $(".dropdown-menu #task-count");
    if (taskCountAlert.length) {
        AccountSettingsService.openTasksCount()
        .then(openTaskCount => {
            if (openTaskCount) {
                taskCountAlert.removeClass("hidden");
                taskCountAlert.text(openTaskCount);
                $(".tasks .alert").removeClass("hidden");
            }
        }).catch(() => { /* don't disrupt user if count unavailable */ });
    }
}

function wireUpHelpPanel(){
    // Help panel toggle
    $('.utility-nav .help, #help-menu .close').on('click', function(e) {
        e.preventDefault();
        $('#help-menu').toggleClass('open');
    });
    window.fn = window.fn || {};
    window.fn.setFaq = (hash) => {
        let currentFaqs = $(`#faq-${hash.substr(1)}`);
        if (currentFaqs.length > 0) {
            $('#help-menu #faqs').html(currentFaqs.clone());
        }
    };
}

document.addEventListener("DOMContentLoaded", function() {
    wireUpExceptionHandlers();
    initializeValidators();
    wireUpMobileLayout();
    openTasksCount();
    wireUpHelpPanel();

    //initialize all the custom animations for bootstrap-material-design
    $.material.init();
});


// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/app.js